import { Component, Input } from '@angular/core';
import MenuOption from '../model/menu-option';
import { MatCard, MatCardHeader, MatCardAvatar, MatCardTitle, MatCardSubtitle, MatCardContent } from '@angular/material/card';
import { NgClass } from '@angular/common';
import { MatIcon } from '@angular/material/icon';
import { MatMenuTrigger, MatMenu, MatMenuItem } from '@angular/material/menu';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'sibat-widget',
  template: `
    <mat-card [ngClass]="[width, borderColor]">
      @if (title || subtitle || menu) {
      <mat-card-header>
        <div mat-card-avatar>
          <ng-content select="[widget-icon]"></ng-content>
        </div>
        <div class="card-header-text">
          <mat-card-title>{{ title }}</mat-card-title>
          <mat-card-subtitle>{{ subtitle }}</mat-card-subtitle>
        </div>
        @if (menu?.length > 0) {
        <mat-icon class="align-right" [matMenuTriggerFor]="menuTrigger">more_vert</mat-icon>
        }
        <mat-menu #menuTrigger="matMenu">
          @for (option of menu; track option) {
          <button [routerLink]="option.route" mat-menu-item>{{ option.text }}</button>
          }
        </mat-menu>
      </mat-card-header>
      }
      <mat-card-content>
        <ng-content select="[widget-content]"></ng-content>
      </mat-card-content>
    </mat-card>
  `,
  styleUrls: ['widget.component.scss'],
  imports: [
    MatCard,
    NgClass,
    MatCardHeader,
    MatCardAvatar,
    MatCardTitle,
    MatCardSubtitle,
    MatIcon,
    MatMenuTrigger,
    MatMenu,
    MatMenuItem,
    RouterLink,
    MatCardContent,
  ],
})
export class WidgetComponent {
  @Input() title: string;
  @Input() subtitle: string;
  @Input() menu: MenuOption[];
  @Input() width: 'small-widget' | 'large-widget' = 'small-widget';
  @Input() borderColor: 'border-none' | 'border-red' = 'border-none';

  constructor() {}
}
